<template style="">
  <div class="Video_release"  v-loading="loading" element-loading-text="上传中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-form label-width="80px" style="padding-top: 20px;">
      <el-form-item label="图片标题">
        <el-input style="width: 300px;" v-model="MaterialName" placeholder="请输入图片标题（5-30个汉字）"></el-input>
      </el-form-item>

      <el-form-item label="上传图片" style="height: 180px;">
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"  accept=".jpg, .jpeg, .png">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <span style="font-size: 16px;">点击选择文件</span>
          </i>
        </el-upload>
        <p style="margin-left: 240px;color: #606266;">请发布与网站主题相关的图片，图片大小需控制在500K以内 文件格式请用.jpg .png .jpeg  图片尺寸建议：2.35:1</p>
      </el-form-item>

      <el-form-item label="栏目">
        <el-select v-model="ItemKey" placeholder="请选择栏目">
          <el-option v-for="(item,index) in columnList" :key="index" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="APP背景" v-if="RoleID=='1057'">
        <el-radio v-model="AppPicture" label="2">首页</el-radio>
        <el-radio v-model="AppPicture" label="3">登录</el-radio>
      </el-form-item>

      <el-form-item label="起止时间">
        <el-date-picker
          v-model="startanend"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd hh:mm:ss"
          >
        </el-date-picker>
      </el-form-item>
  
      <el-form-item label="标签">
        <el-checkbox-group v-model="Label">
          <el-checkbox v-for="(item,index) in tagList" :key="index" :label="item.key">{{ item.value }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit(1)">确定</el-button>
      </el-form-item>

    </el-form>
    <el-dialog
      title="封面裁剪"
      :visible.sync="Croppdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeCroppdialog"
      width="640px">
      <PictureCropper
          ref="picture"
          :initialImg="imageUrl"
          :cropperHeight="cropperHeight"
          :cropperWidth="cropperWidth"
          :autoCropWidth="autoCropWidth"
          :autoCropHeight="autoCropHeight"
          @picturePreview="picturePreview"
        />
      <span slot="footer" class="dialog-footer">
        <el-button @click="Croppdialog=false;">取 消</el-button>
        <el-button type="primary" @click="closeCroppdialog(2)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PictureCropper from '@/components/pictureCropper.vue'
export default {
  components: {PictureCropper},
  data() {
    return {
      RoleID:sessionStorage.getItem('RoleID'),
      AppPicture:'',
      materialKey: '',
      loading:false,
      videopd:false,
      videourl: '',
      videoFile:"",//视频文件
      imageFile:"",//图片文件
      MaterialName: "",//视频标题
      Label: [],//标签
      ItemKey: "",//栏目
      img: "",
      imageUrl: '',
      tagList:[],//标签列表
      columnList: [],//栏目列表
      startanend:[],
      FailureTime:'',
      EnablingTime:'',

      // 裁剪
      Croppdialog:false,
      previews: {},
      cropperHeight: '600px',  // 裁剪图片容器高度
      cropperWidth: '600px',   // 裁剪图片容器宽度
      autoCropWidth: 200,
      autoCropHeight: 200
    }
  },
  watch:{
    startanend(newval,oldval){
      if(newval==null){
        this.FailureTime=''
        this.EnablingTime=''
      }else{
        this.FailureTime=newval[0]
        this.EnablingTime=newval[1]
      }
    }
  },
  mounted() {
    this.materialKey = [this.$route.query.materialKey][0];
    this.$Http_Post('management/tagList',).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.tagList = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })

    this.$Http_Post('management/columnList',).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.columnList = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })

    this.$Http_Post('management/getContentDetails', { MaterialKey: this.materialKey }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.videopd = true;
        this.imageUrl = res.Data.materialPath;
        this.MaterialName = res.Data.materialName;
        this.startanend=[res.Data.failureTime,res.Data.enablingTime];
        this.FailureTime=res.Data.failureTime;
        this.EnablingTime=res.Data.enablingTime;
        this.Label = res.Data.labeles;
        this.ItemKey = res.Data.itemKey.toString();
      } else {
        this.Global.request_failure(res.Message);
      }
    })

  },
  methods: {
    picturePreview(data){
      this.previews = data
    },
    async download(){
      let aLink = document.createElement('a')
      aLink.download = '下载裁剪图片'
      let data = await this.$refs.picture.getBase64()
      aLink.href = data
      aLink.click()
    },

    // 确认裁剪并关闭弹窗
    async closeCroppdialog(e){
      this.Croppdialog=false;
      if(e==2){//确认裁剪并关闭
        this.imageUrl=await this.$refs.picture.getBase64();
        this.imageFile=await this.$refs.picture.getfile(this.imageUrl,Math.floor(new Date().getTime())+'.png');
      }
    },
    onSubmit(type) {//创建
      this.loading = true;
      var from = new FormData();
      from.append('pictureFile', this.imageFile);
      from.append('MaterialName', this.MaterialName);
      from.append('Label', this.Label);
      from.append('ItemKey', this.ItemKey);
      from.append('Type', type);
      from.append('MaterialKey', this.materialKey);
      from.append('AppPicture',this.AppPicture);
      from.append('FailureTime',this.FailureTime);
      from.append('EnablingTime',this.EnablingTime);
      from.append('MaterialLibraryStatus',1);
   
      from.append('RoleID',sessionStorage.getItem('RoleID'));
      this.$Http_Post('management/picturePublishing', from, { 'Content-Type': 'multipart/form-data', })
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.videopd = true;
            this.loading = false;
            this.Global.request_successful(res.Message);
            this.$router.go(-1)
            // this.$router.push({
            //   path: '/propagate/index',
            //   // query: { materialKey: materialKey },
            // })


          } else {
            this.loading = false;
            this.Global.request_failure(res.Message);
          }
        })
    },
    handleChange(file, fileList) {
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.imageFile = file;
        this.Croppdialog=true;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传图片' })
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    videohandleChange(file, fileList) {
      if (file.raw.type == 'audio/mpeg' || file.raw.type == 'audio/mp3' || file.raw.type == 'audio/wma' || file.raw.type == 'audio/wav' || file.raw.type == 'audio/amr' || file.raw.type == 'audio/m4a') {
        this.videoFile = file;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传音频' })
      }
    },

    videohandleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
    },

    videobeforeAvatarUpload(file) {
      // const isLt2M = file.size / 1024 / 1024 < 8
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!')
      // }
      // return isLt2M
    },

    //进度条
    uploadVideoProcess(event, file, fileList) {

    },
  },
}
</script>
<style>
  .Video_release{background-color: #fff;height: 100%;width: 100%;
  }
  /* .avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;} */
.Video_release .avatar-uploader .el-upload:hover {border-color: #409eff;}
.Video_release .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.Video_release .avatar {width: 215px;height: 148px;display: block;}
.Video_release .cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
.Video_release .avatar-uploader {position: absolute;top: 0px;left: 0px;}
.Video_release .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
.Video_release .scale {margin-top: 30px;max-height: 333px;overflow: overlay;}
.Video_release .scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}
</style>
